import { media } from '@payright/web-components';
import styled from 'styled-components';

const SCStep3 = styled.div`
  .alert-container {
    margin-top: 2rem;
  }

  .loading-wrapper {
    margin: 0;
    position: absolute;
    top: 44.85%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .redirect-button {
    margin-top: 1em;
    margin-bottom: 2em;
  }

  .message-title {
    color: ${(props) => props.theme.colours.blue.base};
    font-size: 1.13em;
    font-weight: bold;

    span {
      display: block;
    }

    ${media.min.medium} {
      font-size: 1.53em;
      span {
        display: inline;
      }
    }
  }

  .message-subtitle {
    margin-top: 1em;
  }

  hr {
    border-style: solid;
    border-bottom: none;
    border-color: ${(props) => props.theme.colours.grey.altlight};
    margin: 2.23em 0 3em;
  }
`;

export default SCStep3;
